export default __webpack_public_path__ + "static/media/4.e9ef7e8e.png";